import React, { useEffect, useState } from 'react'
import MainLayout from '../layouts/MainLayout'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getProducts } from '../redux/actions/product';
import { getCategories } from '../redux/actions/category';
import ProductCard from '../components/ProductCard';
import { Spin, Empty, Breadcrumb } from 'antd';
import { Helmet } from 'react-helmet-async';

const Products = () => {
    const { products } = useSelector((state: any) => state.products);
    const { categories } = useSelector((state: any) => state.categories);
    const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch<any>(getProducts());
        dispatch<any>(getCategories());
    }, []);

    const filteredProducts = selectedCategory
        ? products.filter((product: any) => product.category._id === selectedCategory)
        : products;

    const selectedCategoryName = selectedCategory
        ? categories.find((cat: any) => cat._id === selectedCategory)?.name
        : null;

    const breadcrumbItems = [
        {
            title: <a href="/">Anasayfa</a>,
        },
        {
            title: selectedCategoryName ? (
                <a href={`/products?category=${selectedCategory}`}>{selectedCategoryName}</a>
            ) : (
                <span>Lastikler</span>
            ),
        },
    ];

    return (
        <MainLayout>
            <Helmet>
                <title>Ürünler</title>
                <meta name="description" content="Ürünler sayfası" />
                <meta name="keywords" content="ürünler, ürünler sayfası, ürün yazıları" />
                <meta property="og:title" content="Ürünler" />
                <meta property="og:description" content="Ürünler sayfası" />
                <meta property="og:type" content="website" />
            </Helmet>
            <div className='flex w-full bg-gray-50 p-3 border rounded-md'>
                <Breadcrumb items={breadcrumbItems} />
            </div>
            <div className='container mx-auto my-5'>
                <div className='flex gap-5'>
                    <div className="p-3 border rounded-md bg-gray-50 mt-3">
                        <div className='flex flex-col flex-grow-0 gap-3'>
                            <div
                                onClick={() => setSelectedCategory(null)}
                                className={`cursor-pointer p-2 rounded hover:bg-gray-200 ${selectedCategory === null ? 'bg-gray-200' : ''
                                    }`}
                            >
                                Hepsi
                            </div>
                            {categories.length > 0 ? categories?.map((category) => (
                                <div
                                    key={category._id}
                                    onClick={() => setSelectedCategory(category._id)}
                                    className={`whitespace-nowrap cursor-pointer p-2 rounded hover:bg-gray-200 ${selectedCategory === category._id ? 'bg-gray-200' : ''
                                        }`}
                                >
                                    {category.name}
                                </div>
                            )) : <Spin />}
                        </div>
                    </div>

                    <div className='flex flex-col gap-3 mt-3'>
                        {selectedCategoryName && (
                            <h2 className="text-2xl font-bold mb-4">{selectedCategoryName}</h2>
                        )}
                        <div className="flex flex-wrap gap-3">
                            {products.length === 0 ? (
                                <Spin />
                            ) : filteredProducts.length > 0 ? (
                                filteredProducts?.map((product) => (
                                    <ProductCard key={product._id} product={product} />
                                ))
                            ) : (
                                <div className="w-full flex justify-center items-center">
                                    <Empty description="Bu kategoride ürün bulunamadı" />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}

export default Products




